import type { ErrorCopyFor } from "@amtana/browser";
import type { GROWTH_ERROR_CODES } from "@amtana/growth-contract";
import { phrase } from "@amtana/i18n/catalog";
import type { Catalogs, Translation } from "@amtana/i18n/catalog";

// What a person reads when earning credits or inviting fails (packages/module ADR-001).

const EN = {
  taskNotFoundTitle: "That task doesn't exist",
  taskNotFoundDescription: "Reload the page to see the tasks you can do.",
  milestoneLockedTitle: "This milestone isn't reached yet",
  milestoneLockedDescription: "Complete the task first, then claim its credits.",
  eventNotFoundTitle: "That event doesn't exist",
  eventNotFoundDescription: "Reload the page to see the upcoming events.",
} as const;

const ES: Translation<typeof EN> = {
  taskNotFoundTitle: "Esa tarea no existe",
  taskNotFoundDescription: "Recarga la página para ver las tareas que puedes hacer.",
  milestoneLockedTitle: "Aún no llegas a este hito",
  milestoneLockedDescription: "Completa primero la tarea y luego reclama sus créditos.",
  eventNotFoundTitle: "Ese evento no existe",
  eventNotFoundDescription: "Recarga la página para ver los próximos eventos.",
};

export const GROWTH_ERROR_CATALOGS: Catalogs<typeof EN> = { en: EN, es: ES };

export const GROWTH_ERROR_COPY = {
  growth_task_not_found: {
    title: phrase(GROWTH_ERROR_CATALOGS, "taskNotFoundTitle"),
    description: phrase(GROWTH_ERROR_CATALOGS, "taskNotFoundDescription"),
  },
  growth_milestone_locked: {
    title: phrase(GROWTH_ERROR_CATALOGS, "milestoneLockedTitle"),
    description: phrase(GROWTH_ERROR_CATALOGS, "milestoneLockedDescription"),
  },
  growth_event_not_found: {
    title: phrase(GROWTH_ERROR_CATALOGS, "eventNotFoundTitle"),
    description: phrase(GROWTH_ERROR_CATALOGS, "eventNotFoundDescription"),
  },
} satisfies ErrorCopyFor<typeof GROWTH_ERROR_CODES>;
